import React, {useState} from 'react';
import { Modal, Button } from 'react-daisyui';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useRevalidator } from "react-router-dom";

interface ActivateParticipantConfirmModalProps {
  studyId: number;
  isOpen: boolean;
  closeModal: () => void;
  handleSuccessActivation: () => void;
}

const ActivateParticipantConfirmModal: React.FC<ActivateParticipantConfirmModalProps> = ({
  studyId,
  isOpen,
  closeModal,
  handleSuccessActivation
}) => {
  let revalidator = useRevalidator();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);

    try{
      // Initialise survey in limesurvey
      await axios.get(`/api/v1/study/${studyId}/create_survey/`)
      // Give default values
      await axios.get(`/api/v1/study/${studyId}/import_survey_properties/`)
      // Set intro consent
      await axios.get(`/api/v1/study/${studyId}/import_intro_consent/`)
      // Set demographics 
      await axios.get(`/api/v1/study/${studyId}/import_demographics/`)
      // Set measures
      await axios.get(`/api/v1/study/${studyId}/import_groups/`)
      // Set norms
      await axios.get(`/api/v1/study/${studyId}/import_base_groups/`)
      // Set constants
      await axios.get(`/api/v1/study/${studyId}/import_constants/`)
      // Activate Study
      await axios.get(`/api/v1/study/${studyId}/activate_survey/`)
      revalidator.revalidate();
      setLoading(false);
      closeModal();
      handleSuccessActivation();
      toast.success("Study activated successfully!");
    }catch(e){
      toast.error(`${e}`)
    }
    
  };

  return (
    <div className="font-sans">
      <Modal open={isOpen}>
        {/* <Modal.Header className="font-bold">
         Please click on "Confirm" to activate the study and its participants. This will automatically generate a survey in Limesurvey and initiate the process.
         This process is not reverisble and will prevent you from making changes to the study!
        </Modal.Header> */}

        <Modal.Body>
          <div>
            Please click on "Confirm" to activate the study. This will
            automatically generate a survey in Limesurvey and initiate the
            process. This process is not reversible and will prevent you from making changes to the study!
          </div>
          {loading && (
            <div className="mt-4">
              <p className="text-red-500">Processing...</p>
              <p className="text-xs text-gray-500">
                Please do not close the browser while processing.
              </p>
            </div>
          )}
        </Modal.Body>

        <Modal.Actions>
          <Button  id='ModalCancelButton' type='button' onClick={closeModal} disabled={loading}>
            Cancel
          </Button>
          <Button
            id='ModalConfirmButton'
            type='button'
            color="primary"
            className={loading ? "pointer-events-none" : ""} // Disable button while processing
            onClick={loading ? undefined : handleConfirm} // If processing, do nothing
          >
            {loading ? (
              <div className="flex items-center">
                {/* <span className="loading loading-dots loading-md"></span> */}
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Loading...
              </div>
            ) : (
              "Confirm"
            )}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default ActivateParticipantConfirmModal;
